import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpService } from '@crosscutting/public_api';
import { environment } from '@env/environment';
import { ChatConfiguration } from '@models/vragenboom';

@Injectable()
export class ChatConfigurationService {
  constructor(private _http: HttpService) { }

  getConfiguration(sleutel: string): Observable<ChatConfiguration> {
    return this._http.post<ChatConfiguration>(environment.chatConfigurationUrl, {vraagboomkey: sleutel});
  }
}
